/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import Recaptcha from 'react-google-recaptcha';
import { withRouter } from 'react-router';
import SigninPreOTPPage from '@techsoftware/happay-widgets/SignInPreOTPPage';
import SigninPostOTPPage from '@techsoftware/happay-widgets/SignInPostOTPPage';
import Grid from '@techsoftware/happay-widgets/Grid';
import PropTypes from 'prop-types';
import history from '../../utils/history';
import CardProductLogo from '../../assets/images/IPP_product_logo.svg';
import Locales from '../../constants/locales';
const LoginConstants = Locales.JSON.login;

class Reset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      captchaResponse: null,
      resetData: {
        otp: '',
        user: props.location.state.emailId,
        user_id: props.location.state.user_id || null,
      },
    };
    this.onChange = this.onChange.bind(this);
    this.proceedReset = this.proceedReset.bind(this);
    this.onChangeCaptcha = this.onChangeCaptcha.bind(this);
    this.sendOTP = this.sendOTP.bind(this);
    this._checksiteKey = this._checksiteKey.bind(this);
  }

  static getDerivedStateFromProps(nextProps) {
    // console.log("Login ->",nextProps.auth.data);
    const loginStatus = nextProps.auth.login ? nextProps.auth.login.status : 0;
    if (loginStatus === '0') {
      history.push('/');
    }
    return {};
  }

  onChange(event, value, type) {
    const dataSet = { ...this.state.resetData };
    dataSet[type] = value;

    this.setState({
      resetData: dataSet,
    });
  }

  componentWillUnmount() {
    this.props.resetStateForRecaptcha();
  }

  // eslint-disable-next-line consistent-return
  proceedReset(finalData) {
    const loginPayload = {
      user: finalData.user,
      otp: finalData.otp,
    };
    const { resetData } = this.state;
    if (resetData.user_id) {
      loginPayload.user_id = resetData.user_id;
    }
    const sendPayload = {
      formData: loginPayload,
      params: finalData,
    };
    this.props.sendLoginInfo(sendPayload);
  }

  _checksiteKey() {
    const { origin } = window.location;

    if (
      [
        'http://localhost:8080',
        'https://chargecard.uat.happay.com',
        'https://chargecard.uat.happay.in',
        'file://","https://dc0hc3otlytmh.cloudfront.net',
      ].indexOf(origin) !== -1
    ) {
      return '6LdL7T8UAAAAAMxVRrPW8hqpAHWMtRCE2TSDSfuO';
    }
    if (
      origin === 'https://chargecard.happay.com' ||
      origin === 'https://chargecard.happay.in'
    ) {
      return '6Lcu50gUAAAAAHA4Xl55k4PJc-wDA6Jeql64WAOL';
    }
    return '6Lcu50gUAAAAAHA4Xl55k4PJc-wDA6Jeql64WAOL';
  }

  onChangeCaptcha(value) {
    this.setState({
      captchaResponse: value,
    });
  }

  sendOTP() {
    const otpPayload = {
      email_id: this.state.resetData.user,
      response: this.state.captchaResponse,
    };

    this.props.generateOTP(otpPayload);
  }

  render() {
    const { otp } = this.state.resetData;
    return (
      <Grid
        container
        justify="center"
        direction="row"
        className="happayProduct--container"
      >
        {this.state.captchaResponse && this.props.auth.otpSent ? (
          <SigninPostOTPPage
            containerClassName="signin-container"
            logo={CardProductLogo}
            onSignIn={this.proceedReset}
            onClickBack={() => history.goBack()}
            // breakPoints={breakPoints}
            // backGroundImageConfig={backGroundImageConfig}
            data={{ value: this.state.resetData.user }}
            privacyPolicyText="Privacy Policy"
            termOfUseText="Terms of Use"
            privacyPolicyUrl={LoginConstants.PRIVACY_URL}
            termOfUseUrl={LoginConstants.TERMS_URL}
          />
        ) : (
          <div className="margin-t-10 margin-b-10 full-width">
            <SigninPreOTPPage
              containerClassName="signin-container"
              onSignIn={this.sendOTP}
              logo={CardProductLogo}
              onClickBack={() => history.goBack()}
              // backGroundImageConfig={backGroundImageConfig}
              data={{}}
              preOtpHeader="Send OTP"
              getOtpButtonRequired
              // disabledButton
              googleCaptcha={
                <Recaptcha
                  className="padding-10"
                  sitekey={this._checksiteKey()}
                  onChange={this.onChangeCaptcha}
                />
              }
              privacyPolicyText="Privacy Policy"
              termOfUseText="Terms of Use"
              privacyPolicyUrl={LoginConstants.PRIVACY_URL}
              termOfUseUrl={LoginConstants.TERMS_URL}
            />
          </div>
        )}
      </Grid>
    );
  }
}

export default withRouter(Reset);

Reset.propTypes = {
  sendLoginInfo: PropTypes.func,
  generateOTP: PropTypes.func,
  resetStateForRecaptcha: PropTypes.func,
  auth: PropTypes.object,
  location: PropTypes.object,
};
